import type { ActuatorControlNamingMode } from "./types";

let activeActuatorControlNamingMode: ActuatorControlNamingMode = "stableUuid";

export function getActiveActuatorControlNamingMode(): ActuatorControlNamingMode {
  return activeActuatorControlNamingMode;
}

export function setActuatorControlNamingMode(mode: ActuatorControlNamingMode): void {
  activeActuatorControlNamingMode = mode;
}

export function inferActuatorControlNamingModeFromXml(
  xmlString: string
): "stableUuid" | "sceneName" {
  if (!xmlString || typeof xmlString !== "string") return "stableUuid";
  try {
    const actuatorSectionMatch = xmlString.match(
      /<\s*actuator\b[^>]*>([\s\S]*?)<\/\s*actuator\s*>/i
    );
    const actuatorSection = actuatorSectionMatch ? actuatorSectionMatch[1] : "";
    if (!actuatorSection) return "stableUuid";
    const nameMatches = Array.from(
      actuatorSection.matchAll(
        /<\s*(?:general|motor|velocity|intvelocity|position|intposition|damper|cylinder|muscle)\b[^>]*\bname\s*=\s*"([^"]+)"[^>]*>/gi
      )
    );
    const names = nameMatches.map((m) => String(m[1] || ""));
    if (names.length === 0) return "stableUuid";
    const hasStableUuidName = names.some((name) =>
      /^act_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(name)
    );
    return hasStableUuidName ? "stableUuid" : "sceneName";
  } catch {
    return "stableUuid";
  }
}
